import { Directive, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { WishlistItem } from '@df/session/api/wishlist/wishlist-item';
import { Customer } from '@df/session/customer/customer.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { Wishlist } from '../api/wishlist/wishlist';

@Directive()
export abstract class WishlistToggleComponentDef extends UiComponent implements OnInit, OnChanges, OnDestroy {
    /**
     * Product id
     */
    @Input()
    productId?: number;

    /**
     * Item id
     */
    @Input()
    item?: WishlistItem;

    /**
     * Retrieve status model for request processing info
     * @type {object}
     */
    status = new Status();

    protected app = inject(App);
    wishlist = inject(Wishlist);

    protected toggle = this.timeoutService.throttle(() => this._toggle(), 300);

    override ngOnInit() {
        this.subscriptions.add(this.wishlist.subscribe(() => this.detectChanges()));
        super.ngOnInit();
    }

    /**
     * Checks if item is in wishlist already
     */
    get inWishlist(): boolean {
        return !!this.item || (this.productId ? (this.wishlist.getItemsByProduct(this.productId)?.length || 0) > 0 : false);
    }

    /**
     * Toggle item being in wishlist
     */
    protected _toggle(): Promise<Customer.ILoadResponse> | void {
        return this.wishlist.toggle(this.status, (this.item || this.productId)!);
    }

    removeItem() {
        this.wishlist.remove(this.status, this.item!.data.id);
    }
}
